export default {
    props: {
        entrypoint: { required: true },
        formSlug: { required: true },
        initialData: { default: false},
    },

    data: () => ({
            isLoading: false,
            form: {},
            errors: [],
            states: {},
    }),

    mounted() {
    },

    methods: {
        submitForm() {
            this.isLoading = true
            this.$set(this, 'errors', [])
            this.$jmp.bff(this, this.entrypoint, {
                formSlug: this. formSlug,
                form: this.form,
            })
        }
    },

    render(){
        return this.$scopedSlots.default({
            isLoading: this.isLoading,
            form: this.form,
            errors: this.errors,
            submitForm: this.submitForm,
            states: this.states,
        })
    }
}
